<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-form-group :label="$t('semester')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.semester_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('program_name')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.program_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('program_code')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.program_code) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-form-group :label="$t('expected_count')">
                    <b-input-group>
                        <div class="label-as-input">{{ isNotNullValue(form.expected_count) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import ProjectedEnrollmentService from "@/services/ProjectedEnrollmentService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    program_code: null,
                    expected_count: null,
                    semester_name: null,
                    program_name: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                ProjectedEnrollmentService.get(id)
                                      .then((response) => {
                                          this.form = response.data.data;
                                      })
                                      .catch((error) => {
                                          this.showErrors(error)
                                      })
            }
        }
    }
</script>
